import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiEndpoints } from "../../helpers/constants";
import { notify, notifyAPIMessages } from "../../helpers/commonFunction";
import { messages } from "../../helpers/messages";
import Axios, { authHeaders } from "../../helpers/axios";

export const reqToUserLogin = createAsyncThunk(
  apiEndpoints.login,
  async ({ data, onSuccess, onFailure }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(apiEndpoints.login, data);
      onSuccess?.(response);
      return response;
    } catch (error) {
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

export const reqToUserLogout = createAsyncThunk(
  apiEndpoints.logout,
  async ({ data, onSuccess, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.logout,
        data,
        authHeaders()
      );
      onSuccess?.(response);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch(reqToForceUserLogout());
      }
      return rejectWithValue(error);
    }
  }
);

// Create initial state
const initialUser = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;

const initialState = {
  loader: false,
  user: initialUser,
  error: "",
};

// Create user slice
const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    reqToForceUserLogout: (state) => {
      state.user = null;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    },
  },
  extraReducers: (builder) => {
    // USER LOGIN
    builder
      .addCase(reqToUserLogin.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToUserLogin.fulfilled, (state, action) => {
        state.loader = false;
        state.user = {
          ...action.payload.data,
          timein_date: "",
          timeout_date: "",
        };
        notify(messages.toast.login, "success");
        const authToken = action.payload.headers["authorization"];
        localStorage.setItem("token", JSON.stringify(authToken));
        localStorage.setItem(
          "user",
          JSON.stringify({
            ...action.payload.data,
            timein_date: "",
            timeout_date: "",
          })
        );
      })
      .addCase(reqToUserLogin.rejected, (state, action) => {
        state.loader = false;
        notifyAPIMessages(action.payload);
      });

    // USER LOGOUT
    builder
      .addCase(reqToUserLogout.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToUserLogout.fulfilled, (state, action) => {
        state.loader = false;
        if (action.payload.status === 200) {
          state.user = null;
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          notify(messages.toast.logout, "success");
        }
      })
      .addCase(reqToUserLogout.rejected, (state, action) => {
        state.loader = false;
        notifyAPIMessages(action.payload);
      });
  },
});
export const {
  updateUserState,
  reqToUserLoginInLocal,
  reqToUserLogoutInLocal,
  reqToForceUserLogout,
} = userSlice.actions;
export default userSlice.reducer;
